










import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';

@Component({})
export default class Pager extends Vue {
    @Prop({default: []}) collection!: any[];
    @Prop() value!: any;
    @Prop() create!: () => Promise<any>;

    currentPage = 1;

    get total() {
        return this.collection.length;
    }

    @Watch('collection') onCollectionPageChanged() {
        this.input(this.collection[this.currentPage - 1]);
    }

    async handleAdd() {
        if (this.create) {
            const newElement = await this.create();
            if (newElement) {
                this.collection.push(newElement);
                this.input(newElement);
                this.$nextTick(() =>  this.currentPage = this.collection.length + 1);
            }
        }
    }

    handleRemove() {
        this.$nextTick(() => this.currentPage = this.currentPage == 1 ? 1 : this.currentPage - 1);
        if (this.currentPage > 0) {
            const element = this.collection.splice(this.currentPage - 1, 1)[0];
            if (this.collection.length == 0) {
                this.handleAdd();
            }
            this.remove(element);
        }
    }

    handlePageChanged(index) {
        this.input(this.collection[index - 1]);
    }

    @Emit('input') input(page) {}
    @Emit('remove') remove(element: any) {}

    created() {
        this.input(this.collection[this.currentPage - 1]);
    }
}
